import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { Project } from '../types/project';
import customFetch from '../utils/fetch';
export const useUpdateProject = () => {
  const queryClient = useQueryClient();
  const {
    mutate,
    data,
    isPending,
    isSuccess,
    isError,
    error
  } = useMutation({
    mutationKey: ['updateProject'],
    mutationFn: async ({
      groupId,
      projectId
    }: {
      groupId: number;
      projectId: number;
    }) => {
      if (groupId === null || projectId === null) {
        throw new Error('Group ID and Project ID are required');
      }
      const response = await customFetch(`${BASE_API_URL}/projects/${projectId}`, {
        method: 'PATCH',
        body: JSON.stringify({
          userGroupId: groupId
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const {
        success,
        error,
        data
      } = (await response.json() as {
        success: boolean;
        error: string;
        data: Project;
      });
      if (!response.ok || !success) {
        throw new Error(`Failed on update project request: ${error}`);
      }
      queryClient.invalidateQueries({
        queryKey: ['getProjects']
      });
      return {
        data
      };
    }
  });
  return {
    updateProject: mutate,
    actionStatus: data,
    isPending,
    isSuccess,
    isError,
    error
  };
};